import {Form, Input, Submit} from 'components/form'
import APP_CONFIG from 'constants/clientConfigs'
import {AppContext} from 'context/AppContext'
import {useContext, useState} from 'react'
import {Link, useNavigate} from 'react-router-dom'
import {AuthService} from 'rest'
import {useStore} from 'rest/stores'
import {twMerge} from 'tailwind-merge'
import {string, object} from 'yup'

export const SignUpForm = () => {
  const {
    textColor = '',
    hoverTextColor,
    siteName,
    privacyPolicyUrl,
  } = APP_CONFIG[process.env.REACT_APP_CLIENT_ID]
  const {setUser} = useContext(AppContext)
  const navigate = useNavigate()
  const [error, setError] = useState('')
  const {AuthStore} = useStore()
  const {register} = AuthStore
  const schema = object({
    email: string().required(),
    password: string()
      .required()
      .min(6, 'Password should be at least 6 characters long'),
  })

  const onSubmit = async data => {
    setError('')
    const result = await register(data, setUser)

    if (result.status === 201) {
      AuthService.getAuthUser()
      navigate('my-store')
    } else if (result.status === 409) {
      setError('A user with this email already exists')
    }
  }

  return (
    <div className="flex min-h-full flex-1 md:pb-48">
      <div className="flex flex-1 flex-col justify-center px-4 py-12 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
        <div className="mx-auto w-full max-w-sm lg:w-96">
          <div>
            <h2 className="mt-8 text-2xl/9 font-bold tracking-tight text-gray-900">
              Create your coupon page
            </h2>
            <p className="mt-2 text-sm/6 text-gray-500">
              Already have a page?{' '}
              <Link
                to="/login"
                className={twMerge(
                  `font-semibold ${hoverTextColor} ${textColor}`
                )}>
                Sign In
              </Link>
            </p>
          </div>

          <div className="mt-10">
            <div>
              <Form
                schema={schema}
                onSubmit={onSubmit}
                className="flex flex-1 flex-col sm:min-w-[360px]">
                <div className="mt-6">
                  <Input
                    name="email"
                    label="Email address"
                    type="email"
                    placeholder="Your email address"
                    required
                  />
                </div>

                <div className="mt-6">
                  <Input
                    name="password"
                    label="Password"
                    type="password"
                    placeholder="Enter your password"
                    required
                  />
                </div>

                {error && (
                  <div className="bg-red-100 my-2 border border-red-400 text-red-700 px-4 py-3 rounded">
                    <strong className="font-bold">Error: </strong>
                    <span className="block sm:inline">{error}</span>
                  </div>
                )}

                <p className="mt-6 text-center flex justify-center items-center">
                  <span className="w-64 text-sm/6 text-gray-500">
                    By continuing, I agree to {siteName}{' '}
                    <a
                      href={privacyPolicyUrl}
                      target="_blank"
                      className={textColor}
                      rel="noreferrer">
                      Privacy Policy
                    </a>
                  </span>
                </p>

                <Submit className={`primary mt-6`}>
                  NEXT
                  <i className="icon-arrow-narrow-right" />
                </Submit>

                {/* {!!error && (
        <div className="text-red-500 text-sm">An error has occured.</div>
      )} */}
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
